<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="100%"
    height="100%"
    z-index="1000"
    :before-close="handleClose"
  >
    <template slot="title">
      <span class="font-color" style="font-size: 48px">{{ $t("langcfg.txtPrintReport") }}</span>
    </template>
    <webview
      :style="`height:${dispH - 130}px;`"
      :src="`file://${printHtmlUrl}`"
      ref="wviewPrint"
      :preload="`file://${preload_path}`"
    ></webview>
    <webview
      :style="`height:${dispH - 130}px;`"
      :src="printHtmlUrl_brother"
      ref="wviewPrint_brother"
      style="display: none"
    ></webview>
    <el-row slot="footer" class="dialog-footer">
      <el-button
        :disabled="!isBtnEnabled"
        style="font-size: 28px"
        type="info"
        @click="uploadPdfToServer"
        >{{ $t("langcfg.txtUploadDICOMServer") }}</el-button
      >
      <el-button
        :disabled="!isBtnEnabled"
        style="font-size: 28px"
        type="info"
        @click="convertPdfFile()"
        >{{ $t("langcfg.txtPrintToPDF") }}</el-button
      >
      <el-button
        :disabled="!isBtnEnabled"
        style="font-size: 28px"
        type="info"
        v-if="isZHCN"
        @click="sendPdfFile2uploadThirdparty"
        >{{ $t("langcfg.txtUpload2Thirdparty") }}</el-button
      >
      <el-button
        :disabled="!isBtnEnabled"
        style="font-size: 28px"
        type="info"
        @click="convertPdfFile2Folder"
        >{{ $t("langcfg.txtPrintToPDF2ShareFolder") }}</el-button
      >
      <el-button
        :disabled="!isBtnEnabled"
        style="font-size: 28px"
        type="info"
        @click="buildPrintPaper"
        >{{ $t("langcfg.txtPrint") }}</el-button
      >
      <el-button style="font-size: 28px" type="info" @click="handleClose">{{
        $t("langcfg.txtCancel")
      }}</el-button>
    </el-row>
  </el-dialog>
</template>
<script>
import CalcReportDate from "../js/reportDataHanld";
import Drawcanvas from "../js/drawReportCanvas";
import fileSys from "../../fileoprators/fileSystem";
import printReport from "../../mainInterface/js/printer/print";
import { getSystemTime, isDefined, getImageUrl } from "../../shared/utils";
import { Message, Size } from "../../mixins";
import EVENTS from "../../bus";
import Dicom from "../../mainInterface/js/dicom/Dicom";
import { downloadFileLipidLayer, uploadFilesLipidLayer } from "../../services/media";
import { PDFDocument } from "pdf-lib";
let dicom = new Dicom();
const ejs = window.require("ejs");
let reportDataHandle = new CalcReportDate();
let path = window.require("path");
const { remote } = window.require("electron");
const preload_path = fileSys.getUtilPath("webview_print_preload.js");
function adjustPageIsExist(objOne, objTwo, sex, callback) {
  let needhiddenFuns = {}; // 需要整个隐藏的功能
  let needshowFuns = []; // 记录需要显示的功能
  let recordOneKey = Object.keys(objOne);
  let recordTwoKey = Object.keys(objTwo);

  for (let k = 0; k < recordOneKey.length; k++) {
    for (let x = 0; x < recordTwoKey.length; x++) {
      if (recordOneKey[k] === recordTwoKey[x]) {
        if (
          objOne[`${recordOneKey[k]}`].exist === false &&
          objTwo[`${recordTwoKey[k]}`].exist === false
        ) {
          needhiddenFuns[`${recordOneKey[k]}`] = false;
        } else if (objOne[`${recordOneKey[k]}`].exist === true) {
          needshowFuns.push(`${recordOneKey[k]}`);
        } else if (objTwo[`${recordTwoKey[k]}`].exist === true) {
          needshowFuns.push(`${recordTwoKey[k]}`);
        }
      }
    }
  }

  callback(needhiddenFuns, needshowFuns);
}
// let rootpath = window.require('electron').remote.getGlobal('mainEnv').syspath.root + '/'
export default {
  components: {
    // Dicom,

    CalcReportDate
  },
  mixins: [Message, Size],
  props: {
    patient: {
      type: Object
    },
    printBaseInfo: Object,
    recordOneInfo: {
      type: Object,
      default: function () {
        return {};
      }
    },
    recordTwoInfo: {
      type: Object,
      default: function () {
        return {};
      }
    },
    selectedVersion: {
      type: String,
      default: "1"
    },
    whichRecordSelected: Array,
    recordList: {
      type: Array
    },
    record: {
      type: Object,
      default: () => {}
    },
    currentEye: {
      type: String,
      default: "OS"
    }
  },
  data: function () {
    return {
      preload_path,
      dialogVisible: true,
      printHtmlUrl: "",
      printHtmlUrl_brother: "",
      printItemSize: {
        A5: [120, 320, 12, 100, 96],
        A6: [120, 120, 10, 70, 288],
        B5: [120, 400, 14, 160, 96],
        A4: [120, 500, 16, 180, 64],
        USLetter: [150, 500, 16, 200, 64]
      },
      pdfSize: {
        A4: "A4",
        A5: "A5",
        A6: "A6",
        B5: "B5",
        USLetter: "USLetter"
      },
      zoom: 0,
      setPrintItemSize: {
        A5: [120, 120, 320],
        A6: [120, 120, 180],
        B5: [120, 120, 320],
        A4: [120, 120, 320],
        USLetter: [120, 120, 320]
      },
      mediviewSettingCfg: {},
      urlOne: "",
      urlTwo: "",
      showUrlOne: true,
      showUrlTwo: true,
      allFun: [
        "NIBUT",
        "TearHeight",
        "LipidEdge",
        "MeiBomian",
        "EyeRedness",
        "EyeSurface",
        "EyelidEdge"
      ],
      recordOneData: {},
      recordTwoData: {},
      carambolaImg: [],
      needPagination: false,
      selReportMode: "oldReport",
      debugPath: {
        isdebug: true,
        // config:'C:\\Users\\pp\\Desktop\\MediviewMaster\\DEA520\\dea520_app\\static.out\\cfg\\',
        // config:'',
        utils: "../../utils/"
      },
      loading: true,
      changeZoom: 2,
      modalBol: false,
      isBtnEnabled: false,
      isZHCN: false
    };
  },
  mounted() {
    dicom.on("dicom-ok", () => {
      this.message(this.$t("langcfg.txtUploadPdfSuccess"), "success", 2000);
      dicom.clearDicomPath(() => {
        this.afterBtnEvent();
      });
    });
    dicom.on("dicom-failed", () => {
      this.message(this.$t("langcfg.txtUploadPdfFailed"), "error", 2000);
      dicom.clearDicomPath(() => {
        this.afterBtnEvent();
      });
    });
    this.$nextTick(() => {
      remote.ipcMain.on("webview_onload", this.didFinishedLoad);
    });
    this.isZHCN = window.settings.language === "zh_CN";
    if (!this.selectedVersion) {
      this.selReportMode = "oldReport";
    } else if (Number(this.selectedVersion) === 1 && window.settings.language === "zh_CN") {
      this.selReportMode = "oldReport";
    } else if (Number(this.selectedVersion) === 2 && window.settings.language === "zh_CN") {
      this.selReportMode = "newReport";
    } else if (Number(this.selectedVersion) === 3) {
      this.selReportMode = "MeibomianReport";
    } else if (window.settings.language !== "zh_CN") {
      this.selReportMode = "oldReport";
    }
    this.mediviewSettingCfg = window.printSettings;

    this.$bus.$emit(EVENTS.showGlobalWatting, this.$t("langcfg.txtLoading"));
    this.recordOneData = reportDataHandle.dataHandle(this.recordOneInfo, this.selReportMode);
    this.recordTwoData = reportDataHandle.dataHandle(this.recordTwoInfo, this.selReportMode);

    this.constituteEjs();
  },
  beforeDestroy() {
    try {
      remote.ipcMain.off("webview_onload", this.didFinishedLoad);
    } catch (e) {}
  },
  methods: {
    didFinishedLoad() {
      this.isBtnEnabled = true;
    },
    stopPrintReport() {},
    handleClose: function () {
      this.dialogVisible = false;
      this.$emit("close", null);
    },
    renderEjs(url, renderobj, callback) {
      try {
        ejs.renderFile(url, renderobj, (err, str) => {
          console.log("loadtemp try", err);
          callback(str);
        });
      } catch (e) {
        let a = "";
        callback(a);
      }
    },
    getItemStyle: function (item) {},
    drawColorBar: function () {},
    drawCarambola: function (recordInfo) {
      // 绘制能力值图
      let centerx = 200; // 中心点X坐标
      let centery = 80; // 中心点Y坐标
      let size = 60; // 背景图大小
      let scores = {};
      let funsIsExist = {};
      let scoresCount = 0;

      for (let id in recordInfo) {
        if (
          recordInfo[id].score !== undefined &&
          recordInfo[id].score !== "" &&
          (recordInfo[id].Levelup === undefined || !recordInfo[id].Levelup)
        ) {
          // 解决雷达图眼红填充色
          if (recordInfo[id].score || recordInfo[id].score === 0) {
            scoresCount++;
            scores[id] = recordInfo[id].score;
            scores.count = scoresCount;
          }
        }

        if (
          recordInfo[id].exist !== undefined &&
          recordInfo[id].exist !== "" &&
          (recordInfo[id].Levelup === undefined || !recordInfo[id].Levelup)
        ) {
          funsIsExist[id] = recordInfo[id].exist;
        }
      }
      let lang = this.$i18n.messages[this.$i18n.locale].langcfg;

      let myCanvas = new Drawcanvas(lang, { height: 150, width: 445, size: true }, "white");
      myCanvas.drawBackGround(centerx, centery, size, 6);
      myCanvas.drawRadarLine(
        centerx,
        centery,
        size,
        scores,
        funsIsExist,
        window.settings.language,
        6
      );
      let url = myCanvas._canvas.toDataURL("image/jpeg");
      return url;
    },
    constituteEjsForBrother(callback) {
      let that = this;
      let sex =
        this.printBaseInfo.sex === "M"
          ? this.$t("langcfg.txtMale")
          : this.printBaseInfo.sex === "F"
            ? this.$t("langcfg.txtFemale")
            : this.printBaseInfo.sex === "O"
              ? this.$t("langcfg.txtSexOther")
              : this.printBaseInfo.sex === "U"
                ? this.$t("langcfg.txtSexUnknown")
                : "";
      // 加载头页面
      // 打印的数据内容
      if (this.whichRecordSelected[0]) {
        this.carambolaImg.push(this.drawCarambola(this.recordOneData));
      }
      if (this.whichRecordSelected[1]) {
        this.carambolaImg.push(this.drawCarambola(this.recordTwoData));
      }
      // this.renderEjs(`${this.debugPath.config}dryeyeReport/${this.selReportMode}/ReportHead.ejs`, {
      this.renderEjs(
        fileSys.getCfgPath(`dryeyeReport/${this.selReportMode}/ReportHead.ejs`),
        {
          // lang: this.$i18n.messages[this.$i18n.locale].langcfg,
          zoom: 0,
          lang: this.$i18n.messages[this.$i18n.locale].langcfg,
          title:
            this.mediviewSettingCfg.general.title === "Report"
              ? this.selReportMode === "MeibomianReport"
                ? this.$t("langcfg.txtMeibomianGlandReport")
                : this.$t("langcfg.txtPrintReport")
              : this.mediviewSettingCfg.general.title,
          age: this.printBaseInfo.age, // printBaseInfo 里面age字段为空
          sex: sex,
          id: this.printBaseInfo.id,
          name: this.printBaseInfo.lastname
            ? this.printBaseInfo.name + " " + this.printBaseInfo.lastname
            : this.printBaseInfo.name,
          checktype: this.printBaseInfo.checktype, // printBaseInfo里面没有checktype这个字段
          fontsize: this.printItemSize[this.mediviewSettingCfg.general.paper][2],
          hospitalname:
            this.mediviewSettingCfg.general.hospitalname &&
            this.mediviewSettingCfg.general.hospitalname.length > 0
              ? this.mediviewSettingCfg.general.hospitalname
              : "",
          hospitaltel:
            this.mediviewSettingCfg.general.hospitaltel &&
            this.mediviewSettingCfg.general.hospitaltel.length > 0
              ? this.mediviewSettingCfg.general.hospitaltel
              : "",
          hospitaladdr:
            this.mediviewSettingCfg.general.hospitaladdr &&
            this.mediviewSettingCfg.general.hospitaladdr.length > 0
              ? this.mediviewSettingCfg.general.hospitaladdr
              : "",
          hospitallogo: fileSys.getCfgPath(this.mediviewSettingCfg.general.hospitallogo),
          CheckdateOne: this.printBaseInfo.CheckdateOne,
          CheckdateTwo: this.printBaseInfo.CheckdateTwo,
          recordOneEyetype:
            this.recordOneInfo && this.recordOneInfo.data ? this.recordOneInfo.data.type : "",
          recordTwoEyetype:
            this.recordTwoInfo && this.recordTwoInfo.data ? this.recordTwoInfo.data.type : ""
        },
        (str) => {
          let headhtml = str;
          this.renderEjs(
            fileSys.getCfgPath(`dryeyeReport/${this.selReportMode}/ReportTail.ejs`),
            {
              lang: this.$i18n.messages[this.$i18n.locale].langcfg,
              printdate: this.printBaseInfo.printdate,
              checkdoctor: window.printSettings.general.checkdoctor
            },
            (str) => {
              let tailhtml = str;
              this.renderEjs(
                fileSys.getCfgPath(`dryeyeReport/${this.selReportMode}/Carambola.ejs`),
                {
                  carambolaImg: this.carambolaImg,
                  whichRecordSelected: this.whichRecordSelected
                },
                (str) => {
                  let Carambola = str;
                  let needPrintPage = "";
                  adjustPageIsExist(
                    this.recordOneData,
                    this.recordTwoData,
                    sex,
                    (needhiddenFuns, needshowFuns) => {
                      this.constituteContentEjs(
                        needhiddenFuns,
                        needshowFuns,
                        sex,
                        this.selReportMode,
                        (concent) => {
                          needPrintPage = concent;
                          let printHtml = "";
                          if (this.selReportMode === "oldReport") {
                            printHtml = `${headhtml}${Carambola}${needPrintPage}${tailhtml}`; // 需要打印的html
                          } else if (this.selReportMode === "newReport") {
                            printHtml = `${headhtml}${needPrintPage}${tailhtml}`; // 需要打印的html
                          } else if (this.selReportMode === "MeibomianReport") {
                            printHtml = `${headhtml}${needPrintPage}${tailhtml}`;
                          }
                          if (this.debugPath.isdebug) {
                            fileSys.writeFileSync(
                              fileSys.getCfgPath(
                                `dryeyeReport/${this.selReportMode}/newReportTestFor520_brother.html`
                              ),
                              printHtml
                            );
                            this.printHtmlUrl_brother = fileSys.getCfgPath(
                              `dryeyeReport/${this.selReportMode}/newReportTestFor520_brother.html`
                            );
                          } else {
                            fileSys.writeFileSync(
                              path.join(
                                fileSys.getCfgPath(),
                                `../cfg/dryeyeReport/${this.selReportMode}/newReportTestFor520_brother.html`
                              ),
                              printHtml
                            );
                            this.printHtmlUrl_brother = path.join(
                              fileSys.getCfgPath(
                                `../cfg/dryeyeReport/${this.selReportMode}/newReportTestFor520_brother.html`
                              )
                            );
                          }
                          setTimeout(function () {
                            that.loading = false;
                            if (callback) callback();
                          }, 300);
                        }
                      );
                    }
                  );
                }
              );
            }
          );
        }
      );
    },
    getImageSize(url) {
      return new Promise(function (resolve, reject) {
        let image = new Image();
        image.onload = function () {
          resolve({
            width: image.width,
            height: image.height
          });
        };
        image.onerror = function () {
          reject(new Error("error"));
        };
        image.src = url;
      });
    },
    async constituteEjs() {
      let that = this;
      let sex =
        this.printBaseInfo.sex === "M"
          ? this.$t("langcfg.txtMale")
          : this.printBaseInfo.sex === "F"
            ? this.$t("langcfg.txtFemale")
            : this.printBaseInfo.sex === "O"
              ? this.$t("langcfg.txtSexOther")
              : this.printBaseInfo.sex === "U"
                ? this.$t("langcfg.txtSexUnknown")
                : "";
      // 加载头页面
      // 打印的数据内容
      if (this.whichRecordSelected[0]) {
        this.carambolaImg.push(this.drawCarambola(this.recordOneData));
      }
      if (this.whichRecordSelected[1]) {
        this.carambolaImg.push(this.drawCarambola(this.recordTwoData));
      }
      let recordOneDataHeight;
      let recordTwoDataHeight;
      let lipidlayerState = false;
      if (this.recordOneData.LipidLayer.mediafile)
        recordOneDataHeight = await this.getImageSize(this.recordOneData.LipidLayer.mediafile);
      if (this.recordTwoData.LipidLayer.mediafile)
        recordTwoDataHeight = await this.getImageSize(this.recordTwoData.LipidLayer.mediafile);

      if (
        this.recordOneData.LipidLayer.mediafile === "" ||
        (recordOneDataHeight && recordOneDataHeight.height && recordOneDataHeight.height === 768)
      ) {
        lipidlayerState = true;
        let img = getImageUrl(
          this.recordOneInfo.lipidlayer.photos[0].filename,
          window.server,
          window.token
        );
        await downloadFileLipidLayer(
          this.recordOneInfo.lipidlayer.photos[0],
          fileSys.getMediaPath(),
          "lipidLayer.mp4"
        ).then(async () => {
          fileSys.sync();
          await fileSys
            .LipidGetOfflineReportImg(
              fileSys.getMediaPath("lipidLayer.mp4"),
              fileSys.getMediaPath("lipidLayer.jpg")
            )
            .then(async (data) => {
              if (data) {
                await uploadFilesLipidLayer([fileSys.getMediaPath("lipidLayer.jpg")], []).then(
                  (data) => {
                    if (data.message === "proc") return;
                    if (data.message === "OK") {
                      let fileinfo = data.fileInfos[0];
                      fileinfo.imagelabel = "original";
                      if (this.recordOneInfo.lipidlayer.photos.length === 2) {
                        this.recordOneInfo.lipidlayer.photos.pop();
                        this.recordOneInfo.lipidlayer.photos.push(fileinfo);
                      } else {
                        this.recordOneInfo.lipidlayer.photos.push(fileinfo);
                      }
                      this.recordOneData = reportDataHandle.dataHandle(
                        this.recordOneInfo,
                        this.selReportMode
                      );
                      let currentRecord = this.recordList[this.recordOneInfo.data.index];
                      currentRecord.content[
                        `data${this.recordOneInfo.data.type}`
                      ].lipidlayer.photos = this.recordOneInfo.lipidlayer.photos;
                      this.$bus.$emit(EVENTS.updateData, currentRecord, {}, {}, () => {});
                    }
                  }
                );
              }
            });
        });
      }
      if (
        this.recordTwoData.LipidLayer.mediafile === "" ||
        (recordTwoDataHeight && recordTwoDataHeight.height && recordTwoDataHeight.height === 768)
      ) {
        lipidlayerState = true;
        let img = getImageUrl(
          this.recordTwoInfo.lipidlayer.photos[0].filename,
          window.server,
          window.token
        );
        await downloadFileLipidLayer(
          this.recordTwoInfo.lipidlayer.photos[0],
          fileSys.getMediaPath(),
          "lipidLayer.mp4"
        ).then(async () => {
          fileSys.sync();
          await fileSys
            .LipidGetOfflineReportImg(
              fileSys.getMediaPath("lipidLayer.mp4"),
              fileSys.getMediaPath("lipidLayer.jpg")
            )
            .then(async (data) => {
              if (data) {
                await uploadFilesLipidLayer([fileSys.getMediaPath("lipidLayer.jpg")], []).then(
                  (data) => {
                    if (data.message === "proc") return;
                    if (data.message === "OK") {
                      let fileinfo = data.fileInfos[0];
                      fileinfo.imagelabel = "original";
                      if (this.recordTwoInfo.lipidlayer.photos.length === 2) {
                        this.recordTwoInfo.lipidlayer.photos.pop();
                        this.recordTwoInfo.lipidlayer.photos.push(fileinfo);
                      } else {
                        this.recordTwoInfo.lipidlayer.photos.push(fileinfo);
                      }
                      let currentRecord = this.recordList[this.recordTwoInfo.data.index];
                      currentRecord.content[
                        `data${this.recordTwoInfo.data.type}`
                      ].lipidlayer.photos = this.recordTwoInfo.lipidlayer.photos;
                      this.$bus.$emit(EVENTS.updateData, currentRecord, {}, {}, () => {});
                      this.recordTwoData = reportDataHandle.dataHandle(
                        this.recordTwoInfo,
                        this.selReportMode
                      );
                    }
                  }
                );
              }
            });
        });
      }
      this.$bus.$emit(EVENTS.hideGlobalWatting);
      if (lipidlayerState) {
        if (fileSys.isLinux()) {
          let dir = fileSys.getMediaPath();
          fileSys.clearAllFiles(dir, [".mp4", ".jpg", ".raw", "*.pdf"], () => {});
        } else if (fileSys.isWindow()) {
          let __files = fileSys.readDirectory(fileSys.getMediaPath());
          for (let id in __files) {
            fileSys.deleteFile(__files[id]);
          }
        }
      }
      // this.renderEjs(`${this.debugPath.config}dryeyeReport/${this.selReportMode}/ReportHead.ejs`, {
      this.renderEjs(
        fileSys.getCfgPath(`dryeyeReport/${this.selReportMode}/ReportHead.ejs`),
        {
          // lang: this.$i18n.messages[this.$i18n.locale].langcfg,
          zoom: 2.1,
          lang: this.$i18n.messages[this.$i18n.locale].langcfg,
          title:
            this.mediviewSettingCfg.general.title === "Report"
              ? this.selReportMode === "MeibomianReport"
                ? this.$t("langcfg.txtMeibomianGlandReport")
                : this.$t("langcfg.txtPrintReport")
              : this.mediviewSettingCfg.general.title,
          age: this.printBaseInfo.age, // printBaseInfo 里面age字段为空
          sex: sex,
          id: this.printBaseInfo.id,
          name: this.printBaseInfo.lastname
            ? this.printBaseInfo.name + " " + this.printBaseInfo.lastname
            : this.printBaseInfo.name,
          checktype: this.printBaseInfo.checktype, // printBaseInfo里面没有checktype这个字段
          fontsize: this.printItemSize[this.mediviewSettingCfg.general.paper][2],
          hospitalname:
            this.mediviewSettingCfg.general.hospitalname &&
            this.mediviewSettingCfg.general.hospitalname.length > 0
              ? this.mediviewSettingCfg.general.hospitalname
              : "",
          hospitaltel:
            this.mediviewSettingCfg.general.hospitaltel &&
            this.mediviewSettingCfg.general.hospitaltel.length > 0
              ? this.mediviewSettingCfg.general.hospitaltel
              : "",
          hospitaladdr:
            this.mediviewSettingCfg.general.hospitaladdr &&
            this.mediviewSettingCfg.general.hospitaladdr.length > 0
              ? this.mediviewSettingCfg.general.hospitaladdr
              : "",
          hospitallogo: fileSys.getCfgPath(this.mediviewSettingCfg.general.hospitallogo),
          CheckdateOne: this.printBaseInfo.CheckdateOne,
          CheckdateTwo: this.printBaseInfo.CheckdateTwo,
          recordOneEyetype:
            this.recordOneInfo && this.recordOneInfo.data ? this.recordOneInfo.data.type : "",
          recordTwoEyetype:
            this.recordTwoInfo && this.recordTwoInfo.data ? this.recordTwoInfo.data.type : ""
        },
        (str) => {
          let headhtml = str;
          this.renderEjs(
            fileSys.getCfgPath(`dryeyeReport/${this.selReportMode}/ReportTail.ejs`),
            {
              lang: this.$i18n.messages[this.$i18n.locale].langcfg,
              printdate: this.printBaseInfo.printdate,
              checkdoctor: window.printSettings.general.checkdoctor
            },
            (str) => {
              let tailhtml = str;
              this.renderEjs(
                fileSys.getCfgPath(`dryeyeReport/${this.selReportMode}/Carambola.ejs`),
                {
                  carambolaImg: this.carambolaImg,
                  whichRecordSelected: this.whichRecordSelected
                },
                (str) => {
                  let Carambola = str;
                  let needPrintPage = "";
                  adjustPageIsExist(
                    this.recordOneData,
                    this.recordTwoData,
                    sex,
                    (needhiddenFuns, needshowFuns) => {
                      this.constituteContentEjs(
                        needhiddenFuns,
                        needshowFuns,
                        sex,
                        this.selReportMode,
                        (concent) => {
                          needPrintPage = concent;
                          let printHtml = "";
                          let hasNibutAndBut; // nibut fbut 出现条件
                          if (needshowFuns.includes("NIBUT") && needshowFuns.includes("But")) {
                            hasNibutAndBut = true;
                          } else {
                            hasNibutAndBut = false;
                          }
                          if (this.selReportMode === "oldReport") {
                            printHtml = `${headhtml}${Carambola}${needPrintPage}${tailhtml}`;
                          } else if (this.selReportMode === "newReport" && hasNibutAndBut) {
                            printHtml = `${headhtml}${needPrintPage}${tailhtml}`;
                          } else if (this.selReportMode === "newReport" && !hasNibutAndBut) {
                            printHtml = `${headhtml}${needPrintPage}${tailhtml}`;
                          } else if (this.selReportMode === "MeibomianReport") {
                            printHtml = `${headhtml}${needPrintPage}${tailhtml}`;
                          }
                          if (this.debugPath.isdebug) {
                            fileSys.writeFileSync(
                              fileSys.getCfgPath(
                                `dryeyeReport/${this.selReportMode}/newReportTestFor520.html`
                              ),
                              printHtml
                            );
                            this.printHtmlUrl = fileSys.getCfgPath(
                              `dryeyeReport/${this.selReportMode}/newReportTestFor520.html`
                            );
                          } else {
                            fileSys.writeFileSync(
                              path.join(
                                fileSys.getCfgPath(),
                                `../cfg/dryeyeReport/${this.selReportMode}/newReportTestFor520.html`
                              ),
                              printHtml
                            );
                            this.printHtmlUrl = path.join(
                              fileSys.getCfgPath(
                                `../cfg/dryeyeReport/${this.selReportMode}/newReportTestFor520.html`
                              )
                            );
                          }
                          setTimeout(function () {
                            that.loading = false;
                          }, 300);
                        }
                      );
                    }
                  );
                }
              );
            }
          );
        }
      );
    },
    constituteContentEjs(needhiddenFuns, needshowFuns, sex, selReportMode, callback) {
      let content = "";
      this.needPagination = false;
      let reportState = true;
      let heightOfEachModule = {
        oldReport: {
          TearHeight: 29,
          NIBUT: 63,
          LipidLayer: 46,
          MeiBomian: 90,
          EyelidEdge: 64,
          EyeRedness: 45.2,
          But: 35,
          Blink: 30,
          Opi: 29,
          EyeSurface: 61
        },
        newReport: {
          TearHeight: 20.2,
          NIBUT: 53,
          LipidLayer: 38.1,
          MeiBomian: 76,
          EyelidEdge: 56.6,
          EyeRedness: 36.6,
          But: 33,
          Blink: 30,
          Opi: 29,
          EyeSurface: 54
        }
      };
      let oldTotalHeight = 0;
      let newTotalHeight = 0;
      let colorBarCanvas = new Drawcanvas(
        undefined,
        { height: 25, width: 290, size: true },
        "white"
      );
      if (selReportMode !== "MeibomianReport") {
        // needshowFuns = ['TearHeight', 'NIBUT', 'LipidLayer', 'MeiBomian', 'EyelidEdge', 'EyeRedness', 'But', 'Blink', 'Opi', 'EyeSurface']
        for (let id in needshowFuns) {
          console.log(
            "constituteContentEjs",
            this.recordOneData[needshowFuns[id]],
            this.recordTwoData[needshowFuns[id]]
          );
          oldTotalHeight += heightOfEachModule.oldReport[needshowFuns[id]];
          newTotalHeight += heightOfEachModule.newReport[needshowFuns[id]];
          if (this.recordOneData[needshowFuns[id]].exist) {
            colorBarCanvas.drawPrintColorBar(
              0,
              10,
              290,
              50,
              this.recordOneData[needshowFuns[id]].score
            );
            this.recordOneData[needshowFuns[id]].colorBarUrl =
              colorBarCanvas._canvas.toDataURL("image/jpeg");
          }
          if (this.recordTwoData[needshowFuns[id]].exist) {
            colorBarCanvas.drawPrintColorBar(
              0,
              10,
              290,
              50,
              this.recordTwoData[needshowFuns[id]].score
            );
            this.recordTwoData[needshowFuns[id]].colorBarUrl =
              colorBarCanvas._canvas.toDataURL("image/jpeg");
          }

          // this.renderEjs(`${this.debugPath.config}dryeyeReport/${this.selReportMode}/${needshowFuns[id]}.ejs`, {
          this.renderEjs(
            fileSys.getCfgPath(`dryeyeReport/${this.selReportMode}/${needshowFuns[id]}.ejs`),
            {
              // lang: this.$i18n.messages[this.$i18n.locale].langcfg,
              lang: this.$i18n.messages[this.$i18n.locale].langcfg,
              whichRecordSelected: this.whichRecordSelected,
              language: window.settings.language,
              recordOneData: this.recordOneData,
              recordTwoData: this.recordTwoData
            },
            (str) => {
              if (oldTotalHeight >= 258 && reportState && this.selReportMode === "oldReport") {
                reportState = false;
                this.needPagination = true;
                this.renderEjs(
                  fileSys.getCfgPath(`dryeyeReport/${this.selReportMode}/SecondReportHead.ejs`),
                  {
                    // lang: this.$i18n.messages[this.$i18n.locale].langcfg,
                    lang: this.$i18n.messages[this.$i18n.locale].langcfg,
                    title:
                      this.mediviewSettingCfg.general.title === "Report"
                        ? this.selReportMode === "MeibomianReport"
                          ? this.$t("langcfg.txtMeibomianGlandReport")
                          : this.$t("langcfg.txtPrintReport")
                        : this.mediviewSettingCfg.general.title,
                    hospitallogo: fileSys.getCfgPath(this.mediviewSettingCfg.general.hospitallogo),
                    // hospitallogo: (this.mediviewSettingCfg.general.hospitallogo && this.mediviewSettingCfg.general.hospitallogo.length > 0) ? this.mediviewSettingCfg.general.hospitallogo : fileSys.getCfgPath('/res/logo3.png'),
                    age: this.printBaseInfo.age,
                    sex: sex,
                    id: this.printBaseInfo.id,
                    name: this.printBaseInfo.lastname
                      ? this.printBaseInfo.name + " " + this.printBaseInfo.lastname
                      : this.printBaseInfo.name,
                    height: 258 - (oldTotalHeight - heightOfEachModule.oldReport[needshowFuns[id]]),
                    hospitalname:
                      this.mediviewSettingCfg.general.hospitalname &&
                      this.mediviewSettingCfg.general.hospitalname.length > 0
                        ? this.mediviewSettingCfg.general.hospitalname
                        : "",
                    hospitaltel:
                      this.mediviewSettingCfg.general.hospitaltel &&
                      this.mediviewSettingCfg.general.hospitaltel.length > 0
                        ? this.mediviewSettingCfg.general.hospitaltel
                        : "",
                    hospitaladdr:
                      this.mediviewSettingCfg.general.hospitaladdr &&
                      this.mediviewSettingCfg.general.hospitaladdr.length > 0
                        ? this.mediviewSettingCfg.general.hospitaladdr
                        : "",
                    checktype: this.printBaseInfo.checktype,
                    CheckdateOne: this.printBaseInfo.CheckdateOne,
                    CheckdateTwo: this.printBaseInfo.CheckdateTwo,
                    recordOneEyetype:
                      this.recordOneInfo && this.recordOneInfo.data
                        ? this.recordOneInfo.data.type
                        : "",
                    recordTwoEyetype:
                      this.recordTwoInfo && this.recordTwoInfo.data
                        ? this.recordTwoInfo.data.type
                        : ""
                  },
                  (str) => {
                    content += str;
                  }
                );
              } else if (
                newTotalHeight >= 310 &&
                reportState &&
                this.selReportMode === "newReport"
              ) {
                reportState = false;
                this.needPagination = true;
                this.renderEjs(
                  fileSys.getCfgPath(`dryeyeReport/${this.selReportMode}/SecondReportHead.ejs`),
                  {
                    // lang: this.$i18n.messages[this.$i18n.locale].langcfg,
                    lang: this.$i18n.messages[this.$i18n.locale].langcfg,
                    title:
                      this.mediviewSettingCfg.general.title === "Report"
                        ? this.selReportMode === "MeibomianReport"
                          ? this.$t("langcfg.txtMeibomianGlandReport")
                          : this.$t("langcfg.txtPrintReport")
                        : this.mediviewSettingCfg.general.title,
                    hospitallogo: fileSys.getCfgPath(this.mediviewSettingCfg.general.hospitallogo),
                    // hospitallogo: (this.mediviewSettingCfg.general.hospitallogo && this.mediviewSettingCfg.general.hospitallogo.length > 0) ? this.mediviewSettingCfg.general.hospitallogo : fileSys.getCfgPath('/res/logo3.png'),
                    age: this.printBaseInfo.age,
                    sex: sex,
                    id: this.printBaseInfo.id,
                    name: this.printBaseInfo.lastname
                      ? this.printBaseInfo.name + " " + this.printBaseInfo.lastname
                      : this.printBaseInfo.name,
                    height: 310 - (newTotalHeight - heightOfEachModule.newReport[needshowFuns[id]]),
                    hospitalname:
                      this.mediviewSettingCfg.general.hospitalname &&
                      this.mediviewSettingCfg.general.hospitalname.length > 0
                        ? this.mediviewSettingCfg.general.hospitalname
                        : "",
                    hospitaltel:
                      this.mediviewSettingCfg.general.hospitaltel &&
                      this.mediviewSettingCfg.general.hospitaltel.length > 0
                        ? this.mediviewSettingCfg.general.hospitaltel
                        : "",
                    hospitaladdr:
                      this.mediviewSettingCfg.general.hospitaladdr &&
                      this.mediviewSettingCfg.general.hospitaladdr.length > 0
                        ? this.mediviewSettingCfg.general.hospitaladdr
                        : "",
                    checktype: this.printBaseInfo.checktype,
                    CheckdateOne: this.printBaseInfo.CheckdateOne,
                    CheckdateTwo: this.printBaseInfo.CheckdateTwo,
                    recordOneEyetype:
                      this.recordOneInfo && this.recordOneInfo.data
                        ? this.recordOneInfo.data.type
                        : "",
                    recordTwoEyetype:
                      this.recordTwoInfo && this.recordTwoInfo.data
                        ? this.recordTwoInfo.data.type
                        : ""
                  },
                  (str) => {
                    content += str;
                  }
                );
              }
              content += str;
            }
          );
        }
      } else {
        this.renderEjs(
          fileSys.getCfgPath(`dryeyeReport/MeibomianReport/AloneMeiBomian.ejs`),
          {
            lang: this.$i18n.messages[this.$i18n.locale].langcfg,
            whichRecordSelected: this.whichRecordSelected,
            language: window.settings.language,
            recordOneData: this.recordOneData,
            recordTwoData: this.recordTwoData,
            CheckdateOne: this.printBaseInfo.CheckdateOne,
            CheckdateTwo: this.printBaseInfo.CheckdateTwo,
            recordOneEyetype:
              this.recordOneInfo && this.recordOneInfo.data ? this.recordOneInfo.data.type : "",
            recordTwoEyetype:
              this.recordTwoInfo && this.recordTwoInfo.data ? this.recordTwoInfo.data.type : ""
          },
          (str) => {
            content += str;
          }
        );
      }
      callback(content);
    },
    afterBtnEvent: function () {
      this.$bus.$emit(EVENTS.hideGlobalWatting);
      this.isBtnEnabled = true;
    },
    beforeBtnEvent: function (txt) {
      this.isBtnEnabled = false;
      this.$bus.$emit(EVENTS.showGlobalWatting, txt, 100);
    },
    sendPdfFile2uploadThirdparty() {
      if (
        window.thirdPartySettings &&
        window.thirdPartySettings.auto.value &&
        window.thirdpartyScript &&
        this.patient.thirdData
      ) {
        this.beforeBtnEvent(this.$t("langcfg.txtpdf2server"));
        let filepath = fileSys.getUtilPath("thirdparty/dryeyeReportPdf.pdf");
        if (fileSys.isFileExists(filepath)) {
          fileSys.deleteFile(filepath);
        }
        this.convertPdfFile(filepath, () => {
          window.thirdpartyScript.sendDryeyeData(
            this.patient,
            this.record,
            this.currentEye,
            {
              images: {
                dryeyeReportPdf: {
                  filepath,
                  filename: "dryeyeReportPdf"
                }
              }
            },
            (res) => {
              this.afterBtnEvent();
              this.message(res.message, res.code === 200 ? "success" : "error");
            }
          );
        });
      } else {
        this.message(this.$t("langcfg.txtUploadPdfFailed"), "error", 2000);
      }
    },
    convertPdfFile2Folder: function () {
      const { ip, folder, username, password } = window.settings.sharedFolder;

      fileSys.mountSharedFS([`${ip}/${folder}`, `${username}`, `${password}`], (error) => {
        if (error) {
          this.message(this.$t("langcfg.txtSharedFolderMountFailed"), "error", 2000);
        } else {
          this.beforeBtnEvent();
          const { format, singlepage } = window.printSettings.general;
          const { folderInLinux } = window.settings.sharedFolder;
          let reportName =
            this.selReportMode === "oldReport"
              ? this.$t("langcfg.txtClassicVersion")
              : this.selReportMode === "MeibomianReport"
                ? this.$t("langcfg.txtMeibomianGlandReport")
                : this.$t("langcfg.txtSimpleVersion");
          let eye = `${
            this.recordOneInfo && this.recordOneInfo.data ? this.recordOneInfo.data.type : ""
          }${this.recordTwoInfo && this.recordTwoInfo.data ? this.recordTwoInfo.data.type : ""}`;
          let pdfName = fileSys.normalExportName(
            window.exportOptionSettings.folderName,
            this.patient,
            this.record,
            eye,
            this.$i18n.messages[this.$i18n.locale].langcfg
          );
          let pdfPath =
            window.printSettings.general.format === ".pdf"
              ? fileSys.combinePath(folderInLinux, `${pdfName}_${reportName}.pdf`)
              : fileSys.getDicomTmpFilePath(`${pdfName}_${reportName}.pdf`);
          const imagePath = fileSys.combinePath(folderInLinux, `${pdfName}_${reportName}${format}`);
          this.convertPdfFile(pdfPath, (error) => {
            if (error) {
              this.afterBtnEvent();
              this.message(this.$t("langcfg.txtSavePDFFailed"), "error", 2000);
            } else {
              if (window.printSettings.general.format !== ".pdf") {
                fileSys.convertPDF2Image(pdfPath, imagePath, { singlepage }, (error) => {
                  this.afterBtnEvent();
                  if (error) {
                    this.message(this.$t("langcfg.txtSavePDFFailed"), "error", 2000);
                  } else {
                    this.message(this.$t("langcfg.txtSavePDFSuccess"), "success", 2000);
                  }
                });
              } else {
                this.afterBtnEvent();
                this.message(this.$t("langcfg.txtSavePDFSuccess"), "success", 2000);
              }
            }
          });
        }
      });
    },
    async convertPdfFile(pdfPath, callback) {
      const { status, location } = fileSys.isUDiskExits();
      if (!isDefined(pdfPath) && !status) {
        this.isBtnEnabled = true;
        this.message(this.$t("langcfg.txtDiskIsMountedFailed"), "error", 10000);
        return;
      }
      this.beforeBtnEvent(this.$t("langcfg.txtSavingPdf"));
      const { format, singlepage } = window.printSettings.general;
      let reportName =
        this.selReportMode === "oldReport"
          ? this.$t("langcfg.txtClassicVersion")
          : this.selReportMode === "MeibomianReport"
            ? this.$t("langcfg.txtMeibomianGlandReport")
            : this.$t("langcfg.txtSimpleVersion");
      let eye = `${
        this.recordOneInfo && this.recordOneInfo.data ? this.recordOneInfo.data.type : ""
      }${this.recordTwoInfo && this.recordTwoInfo.data ? this.recordTwoInfo.data.type : ""}`;
      let pdfName = fileSys.normalExportName(
        window.exportOptionSettings.folderName,
        this.patient,
        this.record,
        eye,
        this.$i18n.messages[this.$i18n.locale].langcfg
      );
      let filepathTmp =
        window.printSettings.general.format === ".pdf"
          ? fileSys.combinePath(location, `${pdfName}_${reportName}.pdf`)
          : fileSys.getDicomTmpFilePath(`${pdfName}_${reportName}.pdf`);
      const imagePath = fileSys.combinePath(location, `${pdfName}_${reportName}${format}`);
      this.constituteEjsForBrother(() => {
        setTimeout(() => {
          let filepath = isDefined(pdfPath) ? pdfPath : filepathTmp;
          this.$refs.wviewPrint_brother.getWebContents().printToPDF(
            {
              landscape: this.selReportMode === "MeibomianReport",
              pageSize: "A4"
            },
            (error, data) => {
              if (error) {
                this.afterBtnEvent();
                this.message(this.$t("langcfg.txtSavePDFFailed"), "error", 2000);
                return;
              }
              fileSys.writeFile(filepath, data, (error) => {
                this.afterBtnEvent();
                if (!isDefined(error)) {
                  if (callback) {
                    callback();
                    return;
                  }
                  if (window.printSettings.general.format !== ".pdf") {
                    fileSys.convertPDF2Image(filepath, imagePath, { singlepage }, (error) => {
                      this.afterBtnEvent();
                      if (error) {
                        this.message(this.$t("langcfg.txtSavePDFFailed"), "error", 2000);
                      } else {
                        this.message(this.$t("langcfg.txtSavePDFSuccess"), "success", 2000);
                      }
                    });
                  } else {
                    this.message(this.$t("langcfg.txtSavePDFSuccess"), "success", 2000);
                  }
                } else {
                  this.message(this.$t("langcfg.txtSavePDFFailed"), "error", 2000);
                }
              });
            }
          );
        }, 1300);
      });
    },
    buildPrintPaper() {
      this.constituteEjsForBrother();
      setTimeout(() => {
        this.printRecordReport();
      }, 800);
    },

    genPdf(pdfPath, callback) {
      fileSys.deleteFile(pdfPath);
      this.$refs.wviewPrint_brother.getWebContents().printToPDF(
        {
          landscape: this.selReportMode === "MeibomianReport",
          pageSize: "A4"
        },
        (error, data) => {
          if (error) {
            if (callback) callback(error);
            return;
          }
          fileSys.writeFile(pdfPath, data, async (error) => {
            if (isDefined(error)) {
              let result = "print-failed-printer";
              if (callback) callback(result);
            } else {
              if (callback) callback(null, await PDFDocument.load(data));
            }
          });
        }
      );
    },
    printRecordReport() {
      this.isBtnEnabled = false;
      this.$bus.$emit(EVENTS.showGlobalWatting, this.$t("langcfg.txtPrintLoading"), null, true);
      const pdfPath = fileSys.getMediaPath("dryPrintPDF.pdf");
      setTimeout(() => {
        this.genPdf(pdfPath, (error, pdf) => {
          if (error) {
            this.afterBtnEvent();
            this.message(this.$t("langcfg.txtPrintFailed"), "error", 2000);
          } else {
            const { printConnection } = window.printSettings;
            setTimeout(() => {
              printReport(
                { pdfPath: pdfPath, printConnection, sizes: pdf.getPageCount() },
                (error) => {
                  console.log("print error:", error);
                  this.afterBtnEvent();
                  if (isDefined(error)) {
                    switch (error.status) {
                      case "no_printer":
                        this.message(this.$t("langcfg.txtPrintNoPrinter"), "error", 0);
                        break;
                      case "not_default_printer":
                        this.message(this.$t("langcfg.txtPrintNotDefaultPrinter"), "error", 0);
                        break;
                      case "not_switch_printer":
                        this.message(this.$t("langcfg.txtPrintNotSwitchPrinter"), "error", 0);
                        break;
                      case "get_state_error":
                        this.message(this.$t("langcfg.txtPrintGetStateError"), "error", 0);
                        break;
                      case "empty":
                        this.message(this.$t("langcfg.txtPrintNoPaper"), "error", 0);
                        break;
                      case "cancel":
                        this.message(this.$t("langcfg.txtPrintCancel"), "error", 0);
                        break;
                      default:
                        this.message(
                          this.$t("langcfg.txtPrintError", { error: error.Status || error }),
                          "error",
                          0
                        );
                        break;
                    }
                  } else {
                    this.message(this.$t("langcfg.txtPrintSuccess"), "success", 5000);
                  }
                }
              );
            }, 1000);
          }
        });
      }, 2000);
    },
    clickPlus: function () {
      if (this.zoom < 3) {
        this.zoom += 0.2;
        this.$refs.wviewPrint.setZoomLevel(this.zoom);
      }
    },
    clickMinus: function () {
      if (this.zoom > 0) {
        this.zoom -= 0.2;
        this.$refs.wviewPrint.setZoomLevel(this.zoom);
      }
    },
    photoSize: function (imgs) {
      var imgLength = imgs && imgs.length < 2 ? imgs.length : 0;
      this.printItemSize[this.mediviewSettingCfg.general.paper][0] =
        this.setPrintItemSize[this.mediviewSettingCfg.general.paper][imgLength];
      this.printItemSize[this.mediviewSettingCfg.general.paper][1] =
        this.setPrintItemSize[this.mediviewSettingCfg.general.paper][imgLength];
    },
    uploadPdfToServer: function () {
      let pdfPath = fileSys.getMediaPath(`DryeyeReport_${getSystemTime("", "_", "")}.pdf`);
      this.beforeBtnEvent(this.$t("langcfg.txtpdf2server"));
      this.constituteEjsForBrother(() => {
        setTimeout(() => {
          this.$refs.wviewPrint_brother.getWebContents().printToPDF(
            {
              landscape: this.selReportMode === "MeibomianReport",
              pageSize: "A4"
            },
            (error, data) => {
              console.log(error);
              if (error) throw error;
              fileSys.writeFile(pdfPath, data, (error) => {
                if (!isDefined(error)) {
                  const { format, singlepage } = window.printSettings.general;
                  if (window.printSettings.general.format !== ".pdf") {
                    let tmpImageDir = fileSys.getDicomTmpFilePath("images");
                    let imagePath = fileSys.combinePath(tmpImageDir, `report${format}`);
                    if (!fileSys.isFileExists(tmpImageDir)) {
                      fileSys.mkdirSync(tmpImageDir);
                    }
                    fileSys.convertPDF2Image(pdfPath, imagePath, { singlepage }, (error) => {
                      if (error) {
                        this.message(this.$t("langcfg.txtSavePDFFailed"), "error", 2000);
                      } else {
                        dicom.uploadImage2DicomSvr(this.patient, this.record, tmpImageDir);
                      }
                    });
                  } else {
                    dicom.uploadPdf2DicomSvr(this.patient, pdfPath, this.record);
                  }
                } else {
                  this.afterBtnEvent();
                  this.message(this.$t("langcfg.txtSavePDFFailed"), "error", 2000);
                }
              });
            }
          );
        }, 1000);
      });
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .el-dialog {
  margin: 0 !important;
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 299;
}
/deep/ .el-icon-loading {
  font-size: 40px;
}
/deep/ .el-loading-spinner .el-loading-text {
  font-size: 20px;
}
/deep/ .el-dialog__footer {
  padding: 0 !important;
}
/deep/ .el-dialog__body {
  padding: 30px 0 !important;
}
/deep/ .el-dialog__headerbtn {
  display: none;
}
/deep/ .el-dialog__header {
  display: none;
}
.dialog-footer {
  display: flex;
  .el-button {
    width: 100%;
    border: 1px solid;
    padding: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/dryeye/components/PrintReport.vue